import CampStakerABI from "@/contracts/abis/CampStaker.json";
import CampStakingVaultABI from "@/contracts/abis/CampStakingVault.json";
import CampTimelockEscrowNativeOFTABI from "@/contracts/abis/CampTimelockEscrowNativeOFT.json";

export const CONTRACTS = {
  // Camp Network - CampTimelockEscrowNativeOFT
  CAMP_TIMELOCK_ESCROW: {
    address: "0xD95A17d40a273f1e4400B7dD01810c877E78b733" as const,
    chainId: 484, // Camp Network
    abi: CampTimelockEscrowNativeOFTABI,
  },

  // Camp Network - Camp Native OFT Adapter
  CAMP_NATIVE_OFT_ADAPTER: {
    address: "0x40368666eff4Add443cEf30BBAd2eAcAe5F2cbE8" as const,
    chainId: 484, // Camp Network
    abi: [
      // quoteSend function for fee estimation
      {
        inputs: [
          {
            components: [
              { internalType: "uint32", name: "dstEid", type: "uint32" },
              { internalType: "bytes32", name: "to", type: "bytes32" },
              { internalType: "uint256", name: "amountLD", type: "uint256" },
              { internalType: "uint256", name: "minAmountLD", type: "uint256" },
              { internalType: "bytes", name: "extraOptions", type: "bytes" },
              { internalType: "bytes", name: "composeMsg", type: "bytes" },
              { internalType: "bytes", name: "oftCmd", type: "bytes" },
            ],
            internalType: "struct SendParam",
            name: "_sendParam",
            type: "tuple",
          },
          { internalType: "bool", name: "_payInLzToken", type: "bool" },
        ],
        name: "quoteSend",
        outputs: [
          {
            components: [
              { internalType: "uint256", name: "nativeFee", type: "uint256" },
              { internalType: "uint256", name: "lzTokenFee", type: "uint256" },
            ],
            internalType: "struct MessagingFee",
            name: "msgFee",
            type: "tuple",
          },
        ],
        stateMutability: "view",
        type: "function",
      },
      // removeDust function
      {
        inputs: [
          { internalType: "uint256", name: "_amountLD", type: "uint256" },
        ],
        name: "removeDust",
        outputs: [
          { internalType: "uint256", name: "amountLD", type: "uint256" },
        ],
        stateMutability: "view",
        type: "function",
      },
      // send function for bridging
      {
        inputs: [
          {
            components: [
              { internalType: "uint32", name: "dstEid", type: "uint32" },
              { internalType: "bytes32", name: "to", type: "bytes32" },
              { internalType: "uint256", name: "amountLD", type: "uint256" },
              { internalType: "uint256", name: "minAmountLD", type: "uint256" },
              { internalType: "bytes", name: "extraOptions", type: "bytes" },
              { internalType: "bytes", name: "composeMsg", type: "bytes" },
              { internalType: "bytes", name: "oftCmd", type: "bytes" },
            ],
            internalType: "struct SendParam",
            name: "_sendParam",
            type: "tuple",
          },
          {
            components: [
              { internalType: "uint256", name: "nativeFee", type: "uint256" },
              { internalType: "uint256", name: "lzTokenFee", type: "uint256" },
            ],
            internalType: "struct MessagingFee",
            name: "_fee",
            type: "tuple",
          },
          { internalType: "address", name: "_refundAddress", type: "address" },
        ],
        name: "send",
        outputs: [
          {
            components: [
              { internalType: "bytes32", name: "guid", type: "bytes32" },
              { internalType: "uint64", name: "nonce", type: "uint64" },
              {
                components: [
                  {
                    internalType: "uint256",
                    name: "nativeFee",
                    type: "uint256",
                  },
                  {
                    internalType: "uint256",
                    name: "lzTokenFee",
                    type: "uint256",
                  },
                ],
                internalType: "struct MessagingFee",
                name: "fee",
                type: "tuple",
              },
            ],
            internalType: "struct MessagingReceipt",
            name: "msgReceipt",
            type: "tuple",
          },
          {
            components: [
              {
                internalType: "uint256",
                name: "amountSentLD",
                type: "uint256",
              },
              {
                internalType: "uint256",
                name: "amountReceivedLD",
                type: "uint256",
              },
            ],
            internalType: "struct OFTReceipt",
            name: "oftReceipt",
            type: "tuple",
          },
        ],
        stateMutability: "payable",
        type: "function",
      },
    ] as const,
  },

  // Ethereum Mainnet - CampOFT
  CAMP_OFT: {
    address: "0x84EAac1B2dc3f84D92Ff84c3ec205B1FA74671fC" as const, // Updated to correct CAMP OFT address on Ethereum
    chainId: 1, // Ethereum Mainnet
    abi: [
      {
        inputs: [
          { internalType: "string", name: "_name", type: "string" },
          { internalType: "string", name: "_symbol", type: "string" },
          { internalType: "address", name: "_lzEndpoint", type: "address" },
          { internalType: "address", name: "_delegate", type: "address" },
        ],
        stateMutability: "nonpayable",
        type: "constructor",
      },
      {
        inputs: [
          { internalType: "address", name: "spender", type: "address" },
          { internalType: "uint256", name: "allowance", type: "uint256" },
          { internalType: "uint256", name: "needed", type: "uint256" },
        ],
        name: "ERC20InsufficientAllowance",
        type: "error",
      },
      {
        inputs: [
          { internalType: "address", name: "sender", type: "address" },
          { internalType: "uint256", name: "balance", type: "uint256" },
          { internalType: "uint256", name: "needed", type: "uint256" },
        ],
        name: "ERC20InsufficientBalance",
        type: "error",
      },
      {
        inputs: [
          { internalType: "address", name: "approver", type: "address" },
        ],
        name: "ERC20InvalidApprover",
        type: "error",
      },
      {
        inputs: [
          { internalType: "address", name: "receiver", type: "address" },
        ],
        name: "ERC20InvalidReceiver",
        type: "error",
      },
      {
        inputs: [{ internalType: "address", name: "sender", type: "address" }],
        name: "ERC20InvalidSender",
        type: "error",
      },
      {
        inputs: [{ internalType: "address", name: "spender", type: "address" }],
        name: "ERC20InvalidSpender",
        type: "error",
      },
      { inputs: [], name: "InvalidDelegate", type: "error" },
      { inputs: [], name: "InvalidEndpointCall", type: "error" },
      { inputs: [], name: "InvalidLocalDecimals", type: "error" },
      {
        inputs: [{ internalType: "bytes", name: "options", type: "bytes" }],
        name: "InvalidOptions",
        type: "error",
      },
      { inputs: [], name: "LzTokenUnavailable", type: "error" },
      {
        inputs: [{ internalType: "uint32", name: "eid", type: "uint32" }],
        name: "NoPeer",
        type: "error",
      },
      {
        inputs: [
          { internalType: "uint256", name: "msgValue", type: "uint256" },
        ],
        name: "NotEnoughNative",
        type: "error",
      },
      {
        inputs: [{ internalType: "address", name: "addr", type: "address" }],
        name: "OnlyEndpoint",
        type: "error",
      },
      {
        inputs: [
          { internalType: "uint32", name: "eid", type: "uint32" },
          { internalType: "bytes32", name: "sender", type: "bytes32" },
        ],
        name: "OnlyPeer",
        type: "error",
      },
      { inputs: [], name: "OnlySelf", type: "error" },
      {
        inputs: [{ internalType: "address", name: "owner", type: "address" }],
        name: "OwnableInvalidOwner",
        type: "error",
      },
      {
        inputs: [{ internalType: "address", name: "account", type: "address" }],
        name: "OwnableUnauthorizedAccount",
        type: "error",
      },
      {
        inputs: [{ internalType: "address", name: "token", type: "address" }],
        name: "SafeERC20FailedOperation",
        type: "error",
      },
      {
        inputs: [{ internalType: "bytes", name: "result", type: "bytes" }],
        name: "SimulationResult",
        type: "error",
      },
      {
        inputs: [
          { internalType: "uint256", name: "amountLD", type: "uint256" },
          { internalType: "uint256", name: "minAmountLD", type: "uint256" },
        ],
        name: "SlippageExceeded",
        type: "error",
      },
      {
        anonymous: false,
        inputs: [
          {
            indexed: true,
            internalType: "address",
            name: "owner",
            type: "address",
          },
          {
            indexed: true,
            internalType: "address",
            name: "spender",
            type: "address",
          },
          {
            indexed: false,
            internalType: "uint256",
            name: "value",
            type: "uint256",
          },
        ],
        name: "Approval",
        type: "event",
      },
      {
        anonymous: false,
        inputs: [
          {
            components: [
              { internalType: "uint32", name: "eid", type: "uint32" },
              { internalType: "uint16", name: "msgType", type: "uint16" },
              { internalType: "bytes", name: "options", type: "bytes" },
            ],
            indexed: false,
            internalType: "struct EnforcedOptionParam[]",
            name: "_enforcedOptions",
            type: "tuple[]",
          },
        ],
        name: "EnforcedOptionSet",
        type: "event",
      },
      {
        anonymous: false,
        inputs: [
          {
            indexed: false,
            internalType: "address",
            name: "inspector",
            type: "address",
          },
        ],
        name: "MsgInspectorSet",
        type: "event",
      },
      {
        anonymous: false,
        inputs: [
          {
            indexed: true,
            internalType: "bytes32",
            name: "guid",
            type: "bytes32",
          },
          {
            indexed: false,
            internalType: "uint32",
            name: "srcEid",
            type: "uint32",
          },
          {
            indexed: true,
            internalType: "address",
            name: "toAddress",
            type: "address",
          },
          {
            indexed: false,
            internalType: "uint256",
            name: "amountReceivedLD",
            type: "uint256",
          },
        ],
        name: "OFTReceived",
        type: "event",
      },
      {
        anonymous: false,
        inputs: [
          {
            indexed: true,
            internalType: "bytes32",
            name: "guid",
            type: "bytes32",
          },
          {
            indexed: false,
            internalType: "uint32",
            name: "dstEid",
            type: "uint32",
          },
          {
            indexed: true,
            internalType: "address",
            name: "fromAddress",
            type: "address",
          },
          {
            indexed: false,
            internalType: "uint256",
            name: "amountSentLD",
            type: "uint256",
          },
          {
            indexed: false,
            internalType: "uint256",
            name: "amountReceivedLD",
            type: "uint256",
          },
        ],
        name: "OFTSent",
        type: "event",
      },
      {
        anonymous: false,
        inputs: [
          {
            indexed: true,
            internalType: "address",
            name: "previousOwner",
            type: "address",
          },
          {
            indexed: true,
            internalType: "address",
            name: "newOwner",
            type: "address",
          },
        ],
        name: "OwnershipTransferred",
        type: "event",
      },
      {
        anonymous: false,
        inputs: [
          {
            indexed: false,
            internalType: "uint32",
            name: "eid",
            type: "uint32",
          },
          {
            indexed: false,
            internalType: "bytes32",
            name: "peer",
            type: "bytes32",
          },
        ],
        name: "PeerSet",
        type: "event",
      },
      {
        anonymous: false,
        inputs: [
          {
            indexed: false,
            internalType: "address",
            name: "preCrimeAddress",
            type: "address",
          },
        ],
        name: "PreCrimeSet",
        type: "event",
      },
      {
        anonymous: false,
        inputs: [
          {
            indexed: true,
            internalType: "address",
            name: "from",
            type: "address",
          },
          {
            indexed: true,
            internalType: "address",
            name: "to",
            type: "address",
          },
          {
            indexed: false,
            internalType: "uint256",
            name: "value",
            type: "uint256",
          },
        ],
        name: "Transfer",
        type: "event",
      },
      {
        inputs: [],
        name: "SEND",
        outputs: [{ internalType: "uint16", name: "", type: "uint16" }],
        stateMutability: "view",
        type: "function",
      },
      {
        inputs: [],
        name: "SEND_AND_CALL",
        outputs: [{ internalType: "uint16", name: "", type: "uint16" }],
        stateMutability: "view",
        type: "function",
      },
      {
        inputs: [
          {
            components: [
              { internalType: "uint32", name: "srcEid", type: "uint32" },
              { internalType: "bytes32", name: "sender", type: "bytes32" },
              { internalType: "uint64", name: "nonce", type: "uint64" },
            ],
            internalType: "struct Origin",
            name: "origin",
            type: "tuple",
          },
        ],
        name: "allowInitializePath",
        outputs: [{ internalType: "bool", name: "", type: "bool" }],
        stateMutability: "view",
        type: "function",
      },
      {
        inputs: [
          { internalType: "address", name: "owner", type: "address" },
          { internalType: "address", name: "spender", type: "address" },
        ],
        name: "allowance",
        outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
        stateMutability: "view",
        type: "function",
      },
      {
        inputs: [],
        name: "approvalRequired",
        outputs: [{ internalType: "bool", name: "", type: "bool" }],
        stateMutability: "pure",
        type: "function",
      },
      {
        inputs: [
          { internalType: "address", name: "spender", type: "address" },
          { internalType: "uint256", name: "value", type: "uint256" },
        ],
        name: "approve",
        outputs: [{ internalType: "bool", name: "", type: "bool" }],
        stateMutability: "nonpayable",
        type: "function",
      },
      {
        inputs: [{ internalType: "address", name: "account", type: "address" }],
        name: "balanceOf",
        outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
        stateMutability: "view",
        type: "function",
      },
      {
        inputs: [
          { internalType: "uint32", name: "_eid", type: "uint32" },
          { internalType: "uint16", name: "_msgType", type: "uint16" },
          { internalType: "bytes", name: "_extraOptions", type: "bytes" },
        ],
        name: "combineOptions",
        outputs: [{ internalType: "bytes", name: "", type: "bytes" }],
        stateMutability: "view",
        type: "function",
      },
      {
        inputs: [],
        name: "decimalConversionRate",
        outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
        stateMutability: "view",
        type: "function",
      },
      {
        inputs: [],
        name: "decimals",
        outputs: [{ internalType: "uint8", name: "", type: "uint8" }],
        stateMutability: "view",
        type: "function",
      },
      {
        inputs: [],
        name: "endpoint",
        outputs: [
          {
            internalType: "contract ILayerZeroEndpointV2",
            name: "",
            type: "address",
          },
        ],
        stateMutability: "view",
        type: "function",
      },
      {
        inputs: [
          { internalType: "uint32", name: "eid", type: "uint32" },
          { internalType: "uint16", name: "msgType", type: "uint16" },
        ],
        name: "enforcedOptions",
        outputs: [
          { internalType: "bytes", name: "enforcedOption", type: "bytes" },
        ],
        stateMutability: "view",
        type: "function",
      },
      {
        inputs: [
          {
            components: [
              { internalType: "uint32", name: "srcEid", type: "uint32" },
              { internalType: "bytes32", name: "sender", type: "bytes32" },
              { internalType: "uint64", name: "nonce", type: "uint64" },
            ],
            internalType: "struct Origin",
            name: "",
            type: "tuple",
          },
          { internalType: "bytes", name: "", type: "bytes" },
          { internalType: "address", name: "_sender", type: "address" },
        ],
        name: "isComposeMsgSender",
        outputs: [{ internalType: "bool", name: "", type: "bool" }],
        stateMutability: "view",
        type: "function",
      },
      {
        inputs: [
          { internalType: "uint32", name: "_eid", type: "uint32" },
          { internalType: "bytes32", name: "_peer", type: "bytes32" },
        ],
        name: "isPeer",
        outputs: [{ internalType: "bool", name: "", type: "bool" }],
        stateMutability: "view",
        type: "function",
      },
      {
        inputs: [
          {
            components: [
              { internalType: "uint32", name: "srcEid", type: "uint32" },
              { internalType: "bytes32", name: "sender", type: "bytes32" },
              { internalType: "uint64", name: "nonce", type: "uint64" },
            ],
            internalType: "struct Origin",
            name: "_origin",
            type: "tuple",
          },
          { internalType: "bytes32", name: "_guid", type: "bytes32" },
          { internalType: "bytes", name: "_message", type: "bytes" },
          { internalType: "address", name: "_executor", type: "address" },
          { internalType: "bytes", name: "_extraData", type: "bytes" },
        ],
        name: "lzReceive",
        outputs: [],
        stateMutability: "payable",
        type: "function",
      },
      {
        inputs: [
          {
            components: [
              {
                components: [
                  { internalType: "uint32", name: "srcEid", type: "uint32" },
                  { internalType: "bytes32", name: "sender", type: "bytes32" },
                  { internalType: "uint64", name: "nonce", type: "uint64" },
                ],
                internalType: "struct Origin",
                name: "origin",
                type: "tuple",
              },
              { internalType: "uint32", name: "dstEid", type: "uint32" },
              { internalType: "address", name: "receiver", type: "address" },
              { internalType: "bytes32", name: "guid", type: "bytes32" },
              { internalType: "uint256", name: "value", type: "uint256" },
              { internalType: "address", name: "executor", type: "address" },
              { internalType: "bytes", name: "message", type: "bytes" },
              { internalType: "bytes", name: "extraData", type: "bytes" },
            ],
            internalType: "struct InboundPacket[]",
            name: "_packets",
            type: "tuple[]",
          },
        ],
        name: "lzReceiveAndRevert",
        outputs: [],
        stateMutability: "payable",
        type: "function",
      },
      {
        inputs: [
          {
            components: [
              { internalType: "uint32", name: "srcEid", type: "uint32" },
              { internalType: "bytes32", name: "sender", type: "bytes32" },
              { internalType: "uint64", name: "nonce", type: "uint64" },
            ],
            internalType: "struct Origin",
            name: "_origin",
            type: "tuple",
          },
          { internalType: "bytes32", name: "_guid", type: "bytes32" },
          { internalType: "bytes", name: "_message", type: "bytes" },
          { internalType: "address", name: "_executor", type: "address" },
          { internalType: "bytes", name: "_extraData", type: "bytes" },
        ],
        name: "lzReceiveSimulate",
        outputs: [],
        stateMutability: "payable",
        type: "function",
      },
      {
        inputs: [],
        name: "msgInspector",
        outputs: [{ internalType: "address", name: "", type: "address" }],
        stateMutability: "view",
        type: "function",
      },
      {
        inputs: [],
        name: "name",
        outputs: [{ internalType: "string", name: "", type: "string" }],
        stateMutability: "view",
        type: "function",
      },
      {
        inputs: [
          { internalType: "uint32", name: "", type: "uint32" },
          { internalType: "bytes32", name: "", type: "bytes32" },
        ],
        name: "nextNonce",
        outputs: [{ internalType: "uint64", name: "nonce", type: "uint64" }],
        stateMutability: "view",
        type: "function",
      },
      {
        inputs: [],
        name: "oApp",
        outputs: [{ internalType: "address", name: "", type: "address" }],
        stateMutability: "view",
        type: "function",
      },
      {
        inputs: [],
        name: "oAppVersion",
        outputs: [
          { internalType: "uint64", name: "senderVersion", type: "uint64" },
          { internalType: "uint64", name: "receiverVersion", type: "uint64" },
        ],
        stateMutability: "pure",
        type: "function",
      },
      {
        inputs: [],
        name: "oftVersion",
        outputs: [
          { internalType: "bytes4", name: "interfaceId", type: "bytes4" },
          { internalType: "uint64", name: "version", type: "uint64" },
        ],
        stateMutability: "pure",
        type: "function",
      },
      {
        inputs: [],
        name: "owner",
        outputs: [{ internalType: "address", name: "", type: "address" }],
        stateMutability: "view",
        type: "function",
      },
      {
        inputs: [{ internalType: "uint32", name: "eid", type: "uint32" }],
        name: "peers",
        outputs: [{ internalType: "bytes32", name: "peer", type: "bytes32" }],
        stateMutability: "view",
        type: "function",
      },
      {
        inputs: [],
        name: "preCrime",
        outputs: [{ internalType: "address", name: "", type: "address" }],
        stateMutability: "view",
        type: "function",
      },
      {
        inputs: [
          {
            components: [
              { internalType: "uint32", name: "dstEid", type: "uint32" },
              { internalType: "bytes32", name: "to", type: "bytes32" },
              { internalType: "uint256", name: "amountLD", type: "uint256" },
              { internalType: "uint256", name: "minAmountLD", type: "uint256" },
              { internalType: "bytes", name: "extraOptions", type: "bytes" },
              { internalType: "bytes", name: "composeMsg", type: "bytes" },
              { internalType: "bytes", name: "oftCmd", type: "bytes" },
            ],
            internalType: "struct SendParam",
            name: "_sendParam",
            type: "tuple",
          },
        ],
        name: "quoteOFT",
        outputs: [
          {
            components: [
              { internalType: "uint256", name: "minAmountLD", type: "uint256" },
              { internalType: "uint256", name: "maxAmountLD", type: "uint256" },
            ],
            internalType: "struct OFTLimit",
            name: "oftLimit",
            type: "tuple",
          },
          {
            components: [
              { internalType: "int256", name: "feeAmountLD", type: "int256" },
              { internalType: "string", name: "description", type: "string" },
            ],
            internalType: "struct OFTFeeDetail[]",
            name: "oftFeeDetails",
            type: "tuple[]",
          },
          {
            components: [
              {
                internalType: "uint256",
                name: "amountSentLD",
                type: "uint256",
              },
              {
                internalType: "uint256",
                name: "amountReceivedLD",
                type: "uint256",
              },
            ],
            internalType: "struct OFTReceipt",
            name: "oftReceipt",
            type: "tuple",
          },
        ],
        stateMutability: "view",
        type: "function",
      },
      {
        inputs: [
          {
            components: [
              { internalType: "uint32", name: "dstEid", type: "uint32" },
              { internalType: "bytes32", name: "to", type: "bytes32" },
              { internalType: "uint256", name: "amountLD", type: "uint256" },
              { internalType: "uint256", name: "minAmountLD", type: "uint256" },
              { internalType: "bytes", name: "extraOptions", type: "bytes" },
              { internalType: "bytes", name: "composeMsg", type: "bytes" },
              { internalType: "bytes", name: "oftCmd", type: "bytes" },
            ],
            internalType: "struct SendParam",
            name: "_sendParam",
            type: "tuple",
          },
          { internalType: "bool", name: "_payInLzToken", type: "bool" },
        ],
        name: "quoteSend",
        outputs: [
          {
            components: [
              { internalType: "uint256", name: "nativeFee", type: "uint256" },
              { internalType: "uint256", name: "lzTokenFee", type: "uint256" },
            ],
            internalType: "struct MessagingFee",
            name: "msgFee",
            type: "tuple",
          },
        ],
        stateMutability: "view",
        type: "function",
      },
      {
        inputs: [],
        name: "renounceOwnership",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
      },
      {
        inputs: [
          {
            components: [
              { internalType: "uint32", name: "dstEid", type: "uint32" },
              { internalType: "bytes32", name: "to", type: "bytes32" },
              { internalType: "uint256", name: "amountLD", type: "uint256" },
              { internalType: "uint256", name: "minAmountLD", type: "uint256" },
              { internalType: "bytes", name: "extraOptions", type: "bytes" },
              { internalType: "bytes", name: "composeMsg", type: "bytes" },
              { internalType: "bytes", name: "oftCmd", type: "bytes" },
            ],
            internalType: "struct SendParam",
            name: "_sendParam",
            type: "tuple",
          },
          {
            components: [
              { internalType: "uint256", name: "nativeFee", type: "uint256" },
              { internalType: "uint256", name: "lzTokenFee", type: "uint256" },
            ],
            internalType: "struct MessagingFee",
            name: "_fee",
            type: "tuple",
          },
          { internalType: "address", name: "_refundAddress", type: "address" },
        ],
        name: "send",
        outputs: [
          {
            components: [
              { internalType: "bytes32", name: "guid", type: "bytes32" },
              { internalType: "uint64", name: "nonce", type: "uint64" },
              {
                components: [
                  {
                    internalType: "uint256",
                    name: "nativeFee",
                    type: "uint256",
                  },
                  {
                    internalType: "uint256",
                    name: "lzTokenFee",
                    type: "uint256",
                  },
                ],
                internalType: "struct MessagingFee",
                name: "fee",
                type: "tuple",
              },
            ],
            internalType: "struct MessagingReceipt",
            name: "msgReceipt",
            type: "tuple",
          },
          {
            components: [
              {
                internalType: "uint256",
                name: "amountSentLD",
                type: "uint256",
              },
              {
                internalType: "uint256",
                name: "amountReceivedLD",
                type: "uint256",
              },
            ],
            internalType: "struct OFTReceipt",
            name: "oftReceipt",
            type: "tuple",
          },
        ],
        stateMutability: "payable",
        type: "function",
      },
      {
        inputs: [
          { internalType: "address", name: "_delegate", type: "address" },
        ],
        name: "setDelegate",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
      },
      {
        inputs: [
          {
            components: [
              { internalType: "uint32", name: "eid", type: "uint32" },
              { internalType: "uint16", name: "msgType", type: "uint16" },
              { internalType: "bytes", name: "options", type: "bytes" },
            ],
            internalType: "struct EnforcedOptionParam[]",
            name: "_enforcedOptions",
            type: "tuple[]",
          },
        ],
        name: "setEnforcedOptions",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
      },
      {
        inputs: [
          { internalType: "address", name: "_msgInspector", type: "address" },
        ],
        name: "setMsgInspector",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
      },
      {
        inputs: [
          { internalType: "uint32", name: "_eid", type: "uint32" },
          { internalType: "bytes32", name: "_peer", type: "bytes32" },
        ],
        name: "setPeer",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
      },
      {
        inputs: [
          { internalType: "address", name: "_preCrime", type: "address" },
        ],
        name: "setPreCrime",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
      },
      {
        inputs: [],
        name: "sharedDecimals",
        outputs: [{ internalType: "uint8", name: "", type: "uint8" }],
        stateMutability: "view",
        type: "function",
      },
      {
        inputs: [],
        name: "symbol",
        outputs: [{ internalType: "string", name: "", type: "string" }],
        stateMutability: "view",
        type: "function",
      },
      {
        inputs: [],
        name: "token",
        outputs: [{ internalType: "address", name: "", type: "address" }],
        stateMutability: "view",
        type: "function",
      },
      {
        inputs: [],
        name: "totalSupply",
        outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
        stateMutability: "view",
        type: "function",
      },
      {
        inputs: [
          { internalType: "address", name: "to", type: "address" },
          { internalType: "uint256", name: "value", type: "uint256" },
        ],
        name: "transfer",
        outputs: [{ internalType: "bool", name: "", type: "bool" }],
        stateMutability: "nonpayable",
        type: "function",
      },
      {
        inputs: [
          { internalType: "address", name: "from", type: "address" },
          { internalType: "address", name: "to", type: "address" },
          { internalType: "uint256", name: "value", type: "uint256" },
        ],
        name: "transferFrom",
        outputs: [{ internalType: "bool", name: "", type: "bool" }],
        stateMutability: "nonpayable",
        type: "function",
      },
      {
        inputs: [
          { internalType: "address", name: "newOwner", type: "address" },
        ],
        name: "transferOwnership",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
      },
    ] as const,
  },

  // Staking Contracts - Camp Network
  CAMP_STAKER: {
    address: "0xCbFF9726eD7ecc7e6F45Ca288f2Fb22505bA952f" as const,
    chainId: 484, // Camp Network
    abi: CampStakerABI,
  },

  // Staking Vaults - CAMP only
  CAMP_STAKING_VAULT: {
    address: "0xA3b517fD67a21af560a754aA86DAC6c29B3b5aFf" as const,
    chainId: 484, // Camp Network
    abi: CampStakingVaultABI,
  },

  // ETH Bridge Contracts

  // Ethereum Mainnet - GenericNativeOFTAdapter for ETH bridging
  ETH_NATIVE_OFT_ADAPTER: {
    address: "0xAc79E9Ef69021F9bf7Ccb175611F3115Ff65A44D" as const,
    chainId: 1, // Ethereum Mainnet
    abi: [
      {
        inputs: [
          { internalType: "uint8", name: "_localDecimals", type: "uint8" },
          { internalType: "address", name: "_lzEndpoint", type: "address" },
          { internalType: "address", name: "_delegate", type: "address" },
        ],
        stateMutability: "nonpayable",
        type: "constructor",
      },
      {
        inputs: [
          { internalType: "address", name: "spender", type: "address" },
          { internalType: "uint256", name: "allowance", type: "uint256" },
          { internalType: "uint256", name: "needed", type: "uint256" },
        ],
        name: "ERC20InsufficientAllowance",
        type: "error",
      },
      {
        inputs: [
          { internalType: "address", name: "sender", type: "address" },
          { internalType: "uint256", name: "balance", type: "uint256" },
          { internalType: "uint256", name: "needed", type: "uint256" },
        ],
        name: "ERC20InsufficientBalance",
        type: "error",
      },
      {
        inputs: [
          { internalType: "address", name: "approver", type: "address" },
        ],
        name: "ERC20InvalidApprover",
        type: "error",
      },
      {
        inputs: [
          { internalType: "address", name: "receiver", type: "address" },
        ],
        name: "ERC20InvalidReceiver",
        type: "error",
      },
      {
        inputs: [{ internalType: "address", name: "sender", type: "address" }],
        name: "ERC20InvalidSender",
        type: "error",
      },
      {
        inputs: [{ internalType: "address", name: "spender", type: "address" }],
        name: "ERC20InvalidSpender",
        type: "error",
      },
      { inputs: [], name: "InvalidDelegate", type: "error" },
      { inputs: [], name: "InvalidEndpointCall", type: "error" },
      { inputs: [], name: "InvalidLocalDecimals", type: "error" },
      {
        inputs: [{ internalType: "bytes", name: "options", type: "bytes" }],
        name: "InvalidOptions",
        type: "error",
      },
      { inputs: [], name: "LzTokenUnavailable", type: "error" },
      {
        inputs: [{ internalType: "uint32", name: "eid", type: "uint32" }],
        name: "NoPeer",
        type: "error",
      },
      {
        inputs: [
          { internalType: "uint256", name: "msgValue", type: "uint256" },
        ],
        name: "NotEnoughNative",
        type: "error",
      },
      {
        inputs: [{ internalType: "address", name: "addr", type: "address" }],
        name: "OnlyEndpoint",
        type: "error",
      },
      {
        inputs: [
          { internalType: "uint32", name: "eid", type: "uint32" },
          { internalType: "bytes32", name: "sender", type: "bytes32" },
        ],
        name: "OnlyPeer",
        type: "error",
      },
      { inputs: [], name: "OnlySelf", type: "error" },
      {
        inputs: [{ internalType: "address", name: "owner", type: "address" }],
        name: "OwnableInvalidOwner",
        type: "error",
      },
      {
        inputs: [{ internalType: "address", name: "account", type: "address" }],
        name: "OwnableUnauthorizedAccount",
        type: "error",
      },
      {
        inputs: [{ internalType: "address", name: "token", type: "address" }],
        name: "SafeERC20FailedOperation",
        type: "error",
      },
      {
        inputs: [{ internalType: "bytes", name: "result", type: "bytes" }],
        name: "SimulationResult",
        type: "error",
      },
      {
        inputs: [
          { internalType: "uint256", name: "amountLD", type: "uint256" },
          { internalType: "uint256", name: "minAmountLD", type: "uint256" },
        ],
        name: "SlippageExceeded",
        type: "error",
      },
      {
        anonymous: false,
        inputs: [
          {
            indexed: true,
            internalType: "address",
            name: "owner",
            type: "address",
          },
          {
            indexed: true,
            internalType: "address",
            name: "spender",
            type: "address",
          },
          {
            indexed: false,
            internalType: "uint256",
            name: "value",
            type: "uint256",
          },
        ],
        name: "Approval",
        type: "event",
      },
      {
        anonymous: false,
        inputs: [
          {
            components: [
              { internalType: "uint32", name: "eid", type: "uint32" },
              { internalType: "uint16", name: "msgType", type: "uint16" },
              { internalType: "bytes", name: "options", type: "bytes" },
            ],
            indexed: false,
            internalType: "struct EnforcedOptionParam[]",
            name: "_enforcedOptions",
            type: "tuple[]",
          },
        ],
        name: "EnforcedOptionSet",
        type: "event",
      },
      {
        anonymous: false,
        inputs: [
          {
            indexed: false,
            internalType: "address",
            name: "inspector",
            type: "address",
          },
        ],
        name: "MsgInspectorSet",
        type: "event",
      },
      {
        anonymous: false,
        inputs: [
          {
            indexed: true,
            internalType: "bytes32",
            name: "guid",
            type: "bytes32",
          },
          {
            indexed: false,
            internalType: "uint32",
            name: "srcEid",
            type: "uint32",
          },
          {
            indexed: true,
            internalType: "address",
            name: "toAddress",
            type: "address",
          },
          {
            indexed: false,
            internalType: "uint256",
            name: "amountReceivedLD",
            type: "uint256",
          },
        ],
        name: "OFTReceived",
        type: "event",
      },
      {
        anonymous: false,
        inputs: [
          {
            indexed: true,
            internalType: "bytes32",
            name: "guid",
            type: "bytes32",
          },
          {
            indexed: false,
            internalType: "uint32",
            name: "dstEid",
            type: "uint32",
          },
          {
            indexed: true,
            internalType: "address",
            name: "fromAddress",
            type: "address",
          },
          {
            indexed: false,
            internalType: "uint256",
            name: "amountSentLD",
            type: "uint256",
          },
          {
            indexed: false,
            internalType: "uint256",
            name: "amountReceivedLD",
            type: "uint256",
          },
        ],
        name: "OFTSent",
        type: "event",
      },
      {
        anonymous: false,
        inputs: [
          {
            indexed: true,
            internalType: "address",
            name: "previousOwner",
            type: "address",
          },
          {
            indexed: true,
            internalType: "address",
            name: "newOwner",
            type: "address",
          },
        ],
        name: "OwnershipTransferred",
        type: "event",
      },
      {
        anonymous: false,
        inputs: [
          {
            indexed: false,
            internalType: "uint32",
            name: "eid",
            type: "uint32",
          },
          {
            indexed: false,
            internalType: "bytes32",
            name: "peer",
            type: "bytes32",
          },
        ],
        name: "PeerSet",
        type: "event",
      },
      {
        anonymous: false,
        inputs: [
          {
            indexed: false,
            internalType: "address",
            name: "preCrimeAddress",
            type: "address",
          },
        ],
        name: "PreCrimeSet",
        type: "event",
      },
      {
        anonymous: false,
        inputs: [
          {
            indexed: true,
            internalType: "address",
            name: "from",
            type: "address",
          },
          {
            indexed: true,
            internalType: "address",
            name: "to",
            type: "address",
          },
          {
            indexed: false,
            internalType: "uint256",
            name: "value",
            type: "uint256",
          },
        ],
        name: "Transfer",
        type: "event",
      },
      {
        inputs: [],
        name: "SEND",
        outputs: [{ internalType: "uint16", name: "", type: "uint16" }],
        stateMutability: "view",
        type: "function",
      },
      {
        inputs: [],
        name: "SEND_AND_CALL",
        outputs: [{ internalType: "uint16", name: "", type: "uint16" }],
        stateMutability: "view",
        type: "function",
      },
      {
        inputs: [
          {
            components: [
              { internalType: "uint32", name: "srcEid", type: "uint32" },
              { internalType: "bytes32", name: "sender", type: "bytes32" },
              { internalType: "uint64", name: "nonce", type: "uint64" },
            ],
            internalType: "struct Origin",
            name: "origin",
            type: "tuple",
          },
        ],
        name: "allowInitializePath",
        outputs: [{ internalType: "bool", name: "", type: "bool" }],
        stateMutability: "view",
        type: "function",
      },
      {
        inputs: [
          { internalType: "address", name: "owner", type: "address" },
          { internalType: "address", name: "spender", type: "address" },
        ],
        name: "allowance",
        outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
        stateMutability: "view",
        type: "function",
      },
      {
        inputs: [],
        name: "approvalRequired",
        outputs: [{ internalType: "bool", name: "", type: "bool" }],
        stateMutability: "pure",
        type: "function",
      },
      {
        inputs: [
          { internalType: "address", name: "spender", type: "address" },
          { internalType: "uint256", name: "value", type: "uint256" },
        ],
        name: "approve",
        outputs: [{ internalType: "bool", name: "", type: "bool" }],
        stateMutability: "nonpayable",
        type: "function",
      },
      {
        inputs: [{ internalType: "address", name: "account", type: "address" }],
        name: "balanceOf",
        outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
        stateMutability: "view",
        type: "function",
      },
      {
        inputs: [
          { internalType: "uint32", name: "_eid", type: "uint32" },
          { internalType: "uint16", name: "_msgType", type: "uint16" },
          { internalType: "bytes", name: "_extraOptions", type: "bytes" },
        ],
        name: "combineOptions",
        outputs: [{ internalType: "bytes", name: "", type: "bytes" }],
        stateMutability: "view",
        type: "function",
      },
      {
        inputs: [],
        name: "decimalConversionRate",
        outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
        stateMutability: "view",
        type: "function",
      },
      {
        inputs: [],
        name: "decimals",
        outputs: [{ internalType: "uint8", name: "", type: "uint8" }],
        stateMutability: "view",
        type: "function",
      },
      {
        inputs: [],
        name: "endpoint",
        outputs: [
          {
            internalType: "contract ILayerZeroEndpointV2",
            name: "",
            type: "address",
          },
        ],
        stateMutability: "view",
        type: "function",
      },
      {
        inputs: [
          { internalType: "uint32", name: "eid", type: "uint32" },
          { internalType: "uint16", name: "msgType", type: "uint16" },
        ],
        name: "enforcedOptions",
        outputs: [
          { internalType: "bytes", name: "enforcedOption", type: "bytes" },
        ],
        stateMutability: "view",
        type: "function",
      },
      {
        inputs: [
          {
            components: [
              { internalType: "uint32", name: "srcEid", type: "uint32" },
              { internalType: "bytes32", name: "sender", type: "bytes32" },
              { internalType: "uint64", name: "nonce", type: "uint64" },
            ],
            internalType: "struct Origin",
            name: "",
            type: "tuple",
          },
          { internalType: "bytes", name: "", type: "bytes" },
          { internalType: "address", name: "_sender", type: "address" },
        ],
        name: "isComposeMsgSender",
        outputs: [{ internalType: "bool", name: "", type: "bool" }],
        stateMutability: "view",
        type: "function",
      },
      {
        inputs: [
          { internalType: "uint32", name: "_eid", type: "uint32" },
          { internalType: "bytes32", name: "_peer", type: "bytes32" },
        ],
        name: "isPeer",
        outputs: [{ internalType: "bool", name: "", type: "bool" }],
        stateMutability: "view",
        type: "function",
      },
      {
        inputs: [
          {
            components: [
              { internalType: "uint32", name: "srcEid", type: "uint32" },
              { internalType: "bytes32", name: "sender", type: "bytes32" },
              { internalType: "uint64", name: "nonce", type: "uint64" },
            ],
            internalType: "struct Origin",
            name: "_origin",
            type: "tuple",
          },
          { internalType: "bytes32", name: "_guid", type: "bytes32" },
          { internalType: "bytes", name: "_message", type: "bytes" },
          { internalType: "address", name: "_executor", type: "address" },
          { internalType: "bytes", name: "_extraData", type: "bytes" },
        ],
        name: "lzReceive",
        outputs: [],
        stateMutability: "payable",
        type: "function",
      },
      {
        inputs: [
          {
            components: [
              {
                components: [
                  { internalType: "uint32", name: "srcEid", type: "uint32" },
                  { internalType: "bytes32", name: "sender", type: "bytes32" },
                  { internalType: "uint64", name: "nonce", type: "uint64" },
                ],
                internalType: "struct Origin",
                name: "origin",
                type: "tuple",
              },
              { internalType: "uint32", name: "dstEid", type: "uint32" },
              { internalType: "address", name: "receiver", type: "address" },
              { internalType: "bytes32", name: "guid", type: "bytes32" },
              { internalType: "uint256", name: "value", type: "uint256" },
              { internalType: "address", name: "executor", type: "address" },
              { internalType: "bytes", name: "message", type: "bytes" },
              { internalType: "bytes", name: "extraData", type: "bytes" },
            ],
            internalType: "struct InboundPacket[]",
            name: "_packets",
            type: "tuple[]",
          },
        ],
        name: "lzReceiveAndRevert",
        outputs: [],
        stateMutability: "payable",
        type: "function",
      },
      {
        inputs: [
          {
            components: [
              { internalType: "uint32", name: "srcEid", type: "uint32" },
              { internalType: "bytes32", name: "sender", type: "bytes32" },
              { internalType: "uint64", name: "nonce", type: "uint64" },
            ],
            internalType: "struct Origin",
            name: "_origin",
            type: "tuple",
          },
          { internalType: "bytes32", name: "_guid", type: "bytes32" },
          { internalType: "bytes", name: "_message", type: "bytes" },
          { internalType: "address", name: "_executor", type: "address" },
          { internalType: "bytes", name: "_extraData", type: "bytes" },
        ],
        name: "lzReceiveSimulate",
        outputs: [],
        stateMutability: "payable",
        type: "function",
      },
      {
        inputs: [],
        name: "msgInspector",
        outputs: [{ internalType: "address", name: "", type: "address" }],
        stateMutability: "view",
        type: "function",
      },
      {
        inputs: [],
        name: "name",
        outputs: [{ internalType: "string", name: "", type: "string" }],
        stateMutability: "view",
        type: "function",
      },
      {
        inputs: [
          { internalType: "uint32", name: "", type: "uint32" },
          { internalType: "bytes32", name: "", type: "bytes32" },
        ],
        name: "nextNonce",
        outputs: [{ internalType: "uint64", name: "nonce", type: "uint64" }],
        stateMutability: "view",
        type: "function",
      },
      {
        inputs: [],
        name: "oApp",
        outputs: [{ internalType: "address", name: "", type: "address" }],
        stateMutability: "view",
        type: "function",
      },
      {
        inputs: [],
        name: "oAppVersion",
        outputs: [
          { internalType: "uint64", name: "senderVersion", type: "uint64" },
          { internalType: "uint64", name: "receiverVersion", type: "uint64" },
        ],
        stateMutability: "pure",
        type: "function",
      },
      {
        inputs: [],
        name: "oftVersion",
        outputs: [
          { internalType: "bytes4", name: "interfaceId", type: "bytes4" },
          { internalType: "uint64", name: "version", type: "uint64" },
        ],
        stateMutability: "pure",
        type: "function",
      },
      {
        inputs: [],
        name: "owner",
        outputs: [{ internalType: "address", name: "", type: "address" }],
        stateMutability: "view",
        type: "function",
      },
      {
        inputs: [{ internalType: "uint32", name: "eid", type: "uint32" }],
        name: "peers",
        outputs: [{ internalType: "bytes32", name: "peer", type: "bytes32" }],
        stateMutability: "view",
        type: "function",
      },
      {
        inputs: [],
        name: "preCrime",
        outputs: [{ internalType: "address", name: "", type: "address" }],
        stateMutability: "view",
        type: "function",
      },
      {
        inputs: [
          {
            components: [
              { internalType: "uint32", name: "dstEid", type: "uint32" },
              { internalType: "bytes32", name: "to", type: "bytes32" },
              { internalType: "uint256", name: "amountLD", type: "uint256" },
              { internalType: "uint256", name: "minAmountLD", type: "uint256" },
              { internalType: "bytes", name: "extraOptions", type: "bytes" },
              { internalType: "bytes", name: "composeMsg", type: "bytes" },
              { internalType: "bytes", name: "oftCmd", type: "bytes" },
            ],
            internalType: "struct SendParam",
            name: "_sendParam",
            type: "tuple",
          },
        ],
        name: "quoteOFT",
        outputs: [
          {
            components: [
              { internalType: "uint256", name: "minAmountLD", type: "uint256" },
              { internalType: "uint256", name: "maxAmountLD", type: "uint256" },
            ],
            internalType: "struct OFTLimit",
            name: "oftLimit",
            type: "tuple",
          },
          {
            components: [
              { internalType: "int256", name: "feeAmountLD", type: "int256" },
              { internalType: "string", name: "description", type: "string" },
            ],
            internalType: "struct OFTFeeDetail[]",
            name: "oftFeeDetails",
            type: "tuple[]",
          },
          {
            components: [
              {
                internalType: "uint256",
                name: "amountSentLD",
                type: "uint256",
              },
              {
                internalType: "uint256",
                name: "amountReceivedLD",
                type: "uint256",
              },
            ],
            internalType: "struct OFTReceipt",
            name: "oftReceipt",
            type: "tuple",
          },
        ],
        stateMutability: "view",
        type: "function",
      },
      {
        inputs: [
          {
            components: [
              { internalType: "uint32", name: "dstEid", type: "uint32" },
              { internalType: "bytes32", name: "to", type: "bytes32" },
              { internalType: "uint256", name: "amountLD", type: "uint256" },
              { internalType: "uint256", name: "minAmountLD", type: "uint256" },
              { internalType: "bytes", name: "extraOptions", type: "bytes" },
              { internalType: "bytes", name: "composeMsg", type: "bytes" },
              { internalType: "bytes", name: "oftCmd", type: "bytes" },
            ],
            internalType: "struct SendParam",
            name: "_sendParam",
            type: "tuple",
          },
          { internalType: "bool", name: "_payInLzToken", type: "bool" },
        ],
        name: "quoteSend",
        outputs: [
          {
            components: [
              { internalType: "uint256", name: "nativeFee", type: "uint256" },
              { internalType: "uint256", name: "lzTokenFee", type: "uint256" },
            ],
            internalType: "struct MessagingFee",
            name: "msgFee",
            type: "tuple",
          },
        ],
        stateMutability: "view",
        type: "function",
      },
      {
        inputs: [],
        name: "renounceOwnership",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
      },
      {
        inputs: [
          {
            components: [
              { internalType: "uint32", name: "dstEid", type: "uint32" },
              { internalType: "bytes32", name: "to", type: "bytes32" },
              { internalType: "uint256", name: "amountLD", type: "uint256" },
              { internalType: "uint256", name: "minAmountLD", type: "uint256" },
              { internalType: "bytes", name: "extraOptions", type: "bytes" },
              { internalType: "bytes", name: "composeMsg", type: "bytes" },
              { internalType: "bytes", name: "oftCmd", type: "bytes" },
            ],
            internalType: "struct SendParam",
            name: "_sendParam",
            type: "tuple",
          },
          {
            components: [
              { internalType: "uint256", name: "nativeFee", type: "uint256" },
              { internalType: "uint256", name: "lzTokenFee", type: "uint256" },
            ],
            internalType: "struct MessagingFee",
            name: "_fee",
            type: "tuple",
          },
          { internalType: "address", name: "_refundAddress", type: "address" },
        ],
        name: "send",
        outputs: [
          {
            components: [
              { internalType: "bytes32", name: "guid", type: "bytes32" },
              { internalType: "uint64", name: "nonce", type: "uint64" },
              {
                components: [
                  {
                    internalType: "uint256",
                    name: "nativeFee",
                    type: "uint256",
                  },
                  {
                    internalType: "uint256",
                    name: "lzTokenFee",
                    type: "uint256",
                  },
                ],
                internalType: "struct MessagingFee",
                name: "fee",
                type: "tuple",
              },
            ],
            internalType: "struct MessagingReceipt",
            name: "msgReceipt",
            type: "tuple",
          },
          {
            components: [
              {
                internalType: "uint256",
                name: "amountSentLD",
                type: "uint256",
              },
              {
                internalType: "uint256",
                name: "amountReceivedLD",
                type: "uint256",
              },
            ],
            internalType: "struct OFTReceipt",
            name: "oftReceipt",
            type: "tuple",
          },
        ],
        stateMutability: "payable",
        type: "function",
      },
      {
        inputs: [
          { internalType: "address", name: "_delegate", type: "address" },
        ],
        name: "setDelegate",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
      },
      {
        inputs: [
          {
            components: [
              { internalType: "uint32", name: "eid", type: "uint32" },
              { internalType: "uint16", name: "msgType", type: "uint16" },
              { internalType: "bytes", name: "options", type: "bytes" },
            ],
            internalType: "struct EnforcedOptionParam[]",
            name: "_enforcedOptions",
            type: "tuple[]",
          },
        ],
        name: "setEnforcedOptions",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
      },
      {
        inputs: [
          { internalType: "address", name: "_msgInspector", type: "address" },
        ],
        name: "setMsgInspector",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
      },
      {
        inputs: [
          { internalType: "uint32", name: "_eid", type: "uint32" },
          { internalType: "bytes32", name: "_peer", type: "bytes32" },
        ],
        name: "setPeer",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
      },
      {
        inputs: [
          { internalType: "address", name: "_preCrime", type: "address" },
        ],
        name: "setPreCrime",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
      },
      {
        inputs: [],
        name: "sharedDecimals",
        outputs: [{ internalType: "uint8", name: "", type: "uint8" }],
        stateMutability: "view",
        type: "function",
      },
      {
        inputs: [],
        name: "symbol",
        outputs: [{ internalType: "string", name: "", type: "string" }],
        stateMutability: "view",
        type: "function",
      },
      {
        inputs: [],
        name: "token",
        outputs: [{ internalType: "address", name: "", type: "address" }],
        stateMutability: "view",
        type: "function",
      },
      {
        inputs: [],
        name: "totalSupply",
        outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
        stateMutability: "view",
        type: "function",
      },
      {
        inputs: [
          { internalType: "address", name: "to", type: "address" },
          { internalType: "uint256", name: "value", type: "uint256" },
        ],
        name: "transfer",
        outputs: [{ internalType: "bool", name: "", type: "bool" }],
        stateMutability: "nonpayable",
        type: "function",
      },
      {
        inputs: [
          { internalType: "address", name: "from", type: "address" },
          { internalType: "address", name: "to", type: "address" },
          { internalType: "uint256", name: "value", type: "uint256" },
        ],
        name: "transferFrom",
        outputs: [{ internalType: "bool", name: "", type: "bool" }],
        stateMutability: "nonpayable",
        type: "function",
      },
      {
        inputs: [
          { internalType: "address", name: "newOwner", type: "address" },
        ],
        name: "transferOwnership",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
      },
      { stateMutability: "payable", type: "receive" },
    ] as const,
  },

  // USDC Bridge Contracts

  // Ethereum Mainnet - ERC20TokenOFTAdapter for USDC bridging
  USDC_ERC20_OFT_ADAPTER: {
    address: "0xb55066f2793773B3784f8c57c415a8b5932B33Cd" as const, // ERC20TokenOFTAdapter for USDC bridging on Ethereum
    chainId: 1, // Ethereum Mainnet
    abi: [
      {
        inputs: [
          { internalType: "address", name: "_token", type: "address" },
          { internalType: "address", name: "_lzEndpoint", type: "address" },
          { internalType: "address", name: "_delegate", type: "address" },
        ],
        stateMutability: "nonpayable",
        type: "constructor",
      },
      // Standard OFT functions needed for bridging
      {
        inputs: [
          {
            components: [
              { internalType: "uint32", name: "dstEid", type: "uint32" },
              { internalType: "bytes32", name: "to", type: "bytes32" },
              { internalType: "uint256", name: "amountLD", type: "uint256" },
              { internalType: "uint256", name: "minAmountLD", type: "uint256" },
              { internalType: "bytes", name: "extraOptions", type: "bytes" },
              { internalType: "bytes", name: "composeMsg", type: "bytes" },
              { internalType: "bytes", name: "oftCmd", type: "bytes" },
            ],
            internalType: "struct SendParam",
            name: "_sendParam",
            type: "tuple",
          },
          { internalType: "bool", name: "_payInLzToken", type: "bool" },
        ],
        name: "quoteSend",
        outputs: [
          {
            components: [
              { internalType: "uint256", name: "nativeFee", type: "uint256" },
              { internalType: "uint256", name: "lzTokenFee", type: "uint256" },
            ],
            internalType: "struct MessagingFee",
            name: "msgFee",
            type: "tuple",
          },
        ],
        stateMutability: "view",
        type: "function",
      },
      {
        inputs: [
          {
            components: [
              { internalType: "uint32", name: "dstEid", type: "uint32" },
              { internalType: "bytes32", name: "to", type: "bytes32" },
              { internalType: "uint256", name: "amountLD", type: "uint256" },
              { internalType: "uint256", name: "minAmountLD", type: "uint256" },
              { internalType: "bytes", name: "extraOptions", type: "bytes" },
              { internalType: "bytes", name: "composeMsg", type: "bytes" },
              { internalType: "bytes", name: "oftCmd", type: "bytes" },
            ],
            internalType: "struct SendParam",
            name: "_sendParam",
            type: "tuple",
          },
          {
            components: [
              { internalType: "uint256", name: "nativeFee", type: "uint256" },
              { internalType: "uint256", name: "lzTokenFee", type: "uint256" },
            ],
            internalType: "struct MessagingFee",
            name: "_fee",
            type: "tuple",
          },
          { internalType: "address", name: "_refundAddress", type: "address" },
        ],
        name: "send",
        outputs: [
          {
            components: [
              { internalType: "bytes32", name: "guid", type: "bytes32" },
              { internalType: "uint64", name: "nonce", type: "uint64" },
              {
                components: [
                  {
                    internalType: "uint256",
                    name: "nativeFee",
                    type: "uint256",
                  },
                  {
                    internalType: "uint256",
                    name: "lzTokenFee",
                    type: "uint256",
                  },
                ],
                internalType: "struct MessagingFee",
                name: "fee",
                type: "tuple",
              },
            ],
            internalType: "struct MessagingReceipt",
            name: "msgReceipt",
            type: "tuple",
          },
          {
            components: [
              {
                internalType: "uint256",
                name: "amountSentLD",
                type: "uint256",
              },
              {
                internalType: "uint256",
                name: "amountReceivedLD",
                type: "uint256",
              },
            ],
            internalType: "struct OFTReceipt",
            name: "oftReceipt",
            type: "tuple",
          },
        ],
        stateMutability: "payable",
        type: "function",
      },
    ] as const,
  },

  // USDC ERC20 token on Ethereum (for checking balances and approvals)
  USDC_ERC20_TOKEN: {
    address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48" as const, // USDC contract address on Ethereum
    chainId: 1, // Ethereum Mainnet
    abi: [
      {
        inputs: [{ internalType: "address", name: "account", type: "address" }],
        name: "balanceOf",
        outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
        stateMutability: "view",
        type: "function",
      },
      {
        inputs: [
          { internalType: "address", name: "spender", type: "address" },
          { internalType: "uint256", name: "amount", type: "uint256" },
        ],
        name: "approve",
        outputs: [{ internalType: "bool", name: "", type: "bool" }],
        stateMutability: "nonpayable",
        type: "function",
      },
      {
        inputs: [
          { internalType: "address", name: "owner", type: "address" },
          { internalType: "address", name: "spender", type: "address" },
        ],
        name: "allowance",
        outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
        stateMutability: "view",
        type: "function",
      },
      {
        inputs: [],
        name: "decimals",
        outputs: [{ internalType: "uint8", name: "", type: "uint8" }],
        stateMutability: "view",
        type: "function",
      },
    ] as const,
  },

  // Camp Network - USDC OFT Token
  USDC_OFT_TOKEN: {
    address: "0x977fdEF62CE095Ae8750Fd3496730F24F60dea7a" as const,
    chainId: 484, // Camp Network
    abi: [
      // Error definitions that might be missing
      { inputs: [], name: "InvalidDelegate", type: "error" },
      { inputs: [], name: "InvalidEndpointCall", type: "error" },
      { inputs: [], name: "InvalidLocalDecimals", type: "error" },
      {
        inputs: [{ internalType: "bytes", name: "options", type: "bytes" }],
        name: "InvalidOptions",
        type: "error",
      },
      { inputs: [], name: "LzTokenUnavailable", type: "error" },
      {
        inputs: [{ internalType: "uint32", name: "eid", type: "uint32" }],
        name: "NoPeer",
        type: "error",
      },
      {
        inputs: [
          { internalType: "uint256", name: "msgValue", type: "uint256" },
        ],
        name: "NotEnoughNative",
        type: "error",
      },
      {
        inputs: [{ internalType: "address", name: "addr", type: "address" }],
        name: "OnlyEndpoint",
        type: "error",
      },
      {
        inputs: [
          { internalType: "uint32", name: "eid", type: "uint32" },
          { internalType: "bytes32", name: "sender", type: "bytes32" },
        ],
        name: "OnlyPeer",
        type: "error",
      },
      { inputs: [], name: "OnlySelf", type: "error" },
      {
        inputs: [{ internalType: "address", name: "owner", type: "address" }],
        name: "OwnableInvalidOwner",
        type: "error",
      },
      {
        inputs: [{ internalType: "address", name: "account", type: "address" }],
        name: "OwnableUnauthorizedAccount",
        type: "error",
      },
      {
        inputs: [{ internalType: "address", name: "token", type: "address" }],
        name: "SafeERC20FailedOperation",
        type: "error",
      },
      {
        inputs: [
          { internalType: "uint256", name: "amountLD", type: "uint256" },
          { internalType: "uint256", name: "minAmountLD", type: "uint256" },
        ],
        name: "SlippageExceeded",
        type: "error",
      },
      // Basic ERC20/OFT functions
      {
        inputs: [{ internalType: "address", name: "account", type: "address" }],
        name: "balanceOf",
        outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
        stateMutability: "view",
        type: "function",
      },
      {
        inputs: [],
        name: "decimals",
        outputs: [{ internalType: "uint8", name: "", type: "uint8" }],
        stateMutability: "view",
        type: "function",
      },
      {
        inputs: [],
        name: "symbol",
        outputs: [{ internalType: "string", name: "", type: "string" }],
        stateMutability: "view",
        type: "function",
      },
      {
        inputs: [],
        name: "name",
        outputs: [{ internalType: "string", name: "", type: "string" }],
        stateMutability: "view",
        type: "function",
      },
      // OFT bridging functions
      {
        inputs: [
          {
            components: [
              { internalType: "uint32", name: "dstEid", type: "uint32" },
              { internalType: "bytes32", name: "to", type: "bytes32" },
              { internalType: "uint256", name: "amountLD", type: "uint256" },
              { internalType: "uint256", name: "minAmountLD", type: "uint256" },
              { internalType: "bytes", name: "extraOptions", type: "bytes" },
              { internalType: "bytes", name: "composeMsg", type: "bytes" },
              { internalType: "bytes", name: "oftCmd", type: "bytes" },
            ],
            internalType: "struct SendParam",
            name: "_sendParam",
            type: "tuple",
          },
          { internalType: "bool", name: "_payInLzToken", type: "bool" },
        ],
        name: "quoteSend",
        outputs: [
          {
            components: [
              { internalType: "uint256", name: "nativeFee", type: "uint256" },
              { internalType: "uint256", name: "lzTokenFee", type: "uint256" },
            ],
            internalType: "struct MessagingFee",
            name: "msgFee",
            type: "tuple",
          },
        ],
        stateMutability: "view",
        type: "function",
      },
      {
        inputs: [
          {
            components: [
              { internalType: "uint32", name: "dstEid", type: "uint32" },
              { internalType: "bytes32", name: "to", type: "bytes32" },
              { internalType: "uint256", name: "amountLD", type: "uint256" },
              { internalType: "uint256", name: "minAmountLD", type: "uint256" },
              { internalType: "bytes", name: "extraOptions", type: "bytes" },
              { internalType: "bytes", name: "composeMsg", type: "bytes" },
              { internalType: "bytes", name: "oftCmd", type: "bytes" },
            ],
            internalType: "struct SendParam",
            name: "_sendParam",
            type: "tuple",
          },
          {
            components: [
              { internalType: "uint256", name: "nativeFee", type: "uint256" },
              { internalType: "uint256", name: "lzTokenFee", type: "uint256" },
            ],
            internalType: "struct MessagingFee",
            name: "_fee",
            type: "tuple",
          },
          { internalType: "address", name: "_refundAddress", type: "address" },
        ],
        name: "send",
        outputs: [
          {
            components: [
              { internalType: "bytes32", name: "guid", type: "bytes32" },
              { internalType: "uint64", name: "nonce", type: "uint64" },
              {
                components: [
                  {
                    internalType: "uint256",
                    name: "nativeFee",
                    type: "uint256",
                  },
                  {
                    internalType: "uint256",
                    name: "lzTokenFee",
                    type: "uint256",
                  },
                ],
                internalType: "struct MessagingFee",
                name: "fee",
                type: "tuple",
              },
            ],
            internalType: "struct MessagingReceipt",
            name: "msgReceipt",
            type: "tuple",
          },
          {
            components: [
              {
                internalType: "uint256",
                name: "amountSentLD",
                type: "uint256",
              },
              {
                internalType: "uint256",
                name: "amountReceivedLD",
                type: "uint256",
              },
            ],
            internalType: "struct OFTReceipt",
            name: "oftReceipt",
            type: "tuple",
          },
        ],
        stateMutability: "payable",
        type: "function",
      },
    ] as const,
  },

  // USDC OFT Adapter on Ethereum Mainnet for bridging USDC
  USDC_OFT_ADAPTER: {
    address: "0xb55066f2793773B3784f8c57c415a8b5932B33Cd" as const,
    chainId: 1, // Ethereum Mainnet
    abi: [
      // quoteSend function for fee estimation
      {
        inputs: [
          {
            components: [
              { internalType: "uint32", name: "dstEid", type: "uint32" },
              { internalType: "bytes32", name: "to", type: "bytes32" },
              { internalType: "uint256", name: "amountLD", type: "uint256" },
              { internalType: "uint256", name: "minAmountLD", type: "uint256" },
              { internalType: "bytes", name: "extraOptions", type: "bytes" },
              { internalType: "bytes", name: "composeMsg", type: "bytes" },
              { internalType: "bytes", name: "oftCmd", type: "bytes" },
            ],
            internalType: "struct SendParam",
            name: "_sendParam",
            type: "tuple",
          },
          { internalType: "bool", name: "_payInLzToken", type: "bool" },
        ],
        name: "quoteSend",
        outputs: [
          {
            components: [
              { internalType: "uint256", name: "nativeFee", type: "uint256" },
              { internalType: "uint256", name: "lzTokenFee", type: "uint256" },
            ],
            internalType: "struct MessagingFee",
            name: "msgFee",
            type: "tuple",
          },
        ],
        stateMutability: "view",
        type: "function",
      },
      // send function for bridging
      {
        inputs: [
          {
            components: [
              { internalType: "uint32", name: "dstEid", type: "uint32" },
              { internalType: "bytes32", name: "to", type: "bytes32" },
              { internalType: "uint256", name: "amountLD", type: "uint256" },
              { internalType: "uint256", name: "minAmountLD", type: "uint256" },
              { internalType: "bytes", name: "extraOptions", type: "bytes" },
              { internalType: "bytes", name: "composeMsg", type: "bytes" },
              { internalType: "bytes", name: "oftCmd", type: "bytes" },
            ],
            internalType: "struct SendParam",
            name: "_sendParam",
            type: "tuple",
          },
          {
            components: [
              { internalType: "uint256", name: "nativeFee", type: "uint256" },
              { internalType: "uint256", name: "lzTokenFee", type: "uint256" },
            ],
            internalType: "struct MessagingFee",
            name: "_fee",
            type: "tuple",
          },
          { internalType: "address", name: "_refundAddress", type: "address" },
        ],
        name: "send",
        outputs: [
          {
            components: [
              { internalType: "bytes32", name: "guid", type: "bytes32" },
              { internalType: "uint64", name: "nonce", type: "uint64" },
              {
                components: [
                  {
                    internalType: "uint256",
                    name: "nativeFee",
                    type: "uint256",
                  },
                  {
                    internalType: "uint256",
                    name: "lzTokenFee",
                    type: "uint256",
                  },
                ],
                internalType: "struct MessagingFee",
                name: "fee",
                type: "tuple",
              },
            ],
            internalType: "struct MessagingReceipt",
            name: "msgReceipt",
            type: "tuple",
          },
          {
            components: [
              {
                internalType: "uint256",
                name: "amountSentLD",
                type: "uint256",
              },
              {
                internalType: "uint256",
                name: "amountReceivedLD",
                type: "uint256",
              },
            ],
            internalType: "struct OFTReceipt",
            name: "oftReceipt",
            type: "tuple",
          },
        ],
        stateMutability: "payable",
        type: "function",
      },
      // approve function for USDC allowance
      {
        inputs: [
          { internalType: "address", name: "spender", type: "address" },
          { internalType: "uint256", name: "amount", type: "uint256" },
        ],
        name: "approve",
        outputs: [{ internalType: "bool", name: "", type: "bool" }],
        stateMutability: "nonpayable",
        type: "function",
      },
      // allowance function
      {
        inputs: [
          { internalType: "address", name: "owner", type: "address" },
          { internalType: "address", name: "spender", type: "address" },
        ],
        name: "allowance",
        outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
        stateMutability: "view",
        type: "function",
      },
    ] as const,
  },

  // Camp Network - ETH OFT Token
  ETH_OFT_TOKEN: {
    address: "0xb55066f2793773B3784f8c57c415a8b5932B33Cd" as const, // ETH OFT token on Camp Network
    chainId: 484, // Camp Network
    abi: [
      // Basic ERC20/OFT functions
      {
        inputs: [{ internalType: "address", name: "account", type: "address" }],
        name: "balanceOf",
        outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
        stateMutability: "view",
        type: "function",
      },
      {
        inputs: [],
        name: "decimals",
        outputs: [{ internalType: "uint8", name: "", type: "uint8" }],
        stateMutability: "view",
        type: "function",
      },
      {
        inputs: [],
        name: "symbol",
        outputs: [{ internalType: "string", name: "", type: "string" }],
        stateMutability: "view",
        type: "function",
      },
      {
        inputs: [],
        name: "name",
        outputs: [{ internalType: "string", name: "", type: "string" }],
        stateMutability: "view",
        type: "function",
      },
      // OFT bridging functions
      {
        inputs: [
          {
            components: [
              { internalType: "uint32", name: "dstEid", type: "uint32" },
              { internalType: "bytes32", name: "to", type: "bytes32" },
              { internalType: "uint256", name: "amountLD", type: "uint256" },
              { internalType: "uint256", name: "minAmountLD", type: "uint256" },
              { internalType: "bytes", name: "extraOptions", type: "bytes" },
              { internalType: "bytes", name: "composeMsg", type: "bytes" },
              { internalType: "bytes", name: "oftCmd", type: "bytes" },
            ],
            internalType: "struct SendParam",
            name: "_sendParam",
            type: "tuple",
          },
          { internalType: "bool", name: "_payInLzToken", type: "bool" },
        ],
        name: "quoteSend",
        outputs: [
          {
            components: [
              { internalType: "uint256", name: "nativeFee", type: "uint256" },
              { internalType: "uint256", name: "lzTokenFee", type: "uint256" },
            ],
            internalType: "struct MessagingFee",
            name: "msgFee",
            type: "tuple",
          },
        ],
        stateMutability: "view",
        type: "function",
      },
      {
        inputs: [
          {
            components: [
              { internalType: "uint32", name: "dstEid", type: "uint32" },
              { internalType: "bytes32", name: "to", type: "bytes32" },
              { internalType: "uint256", name: "amountLD", type: "uint256" },
              { internalType: "uint256", name: "minAmountLD", type: "uint256" },
              { internalType: "bytes", name: "extraOptions", type: "bytes" },
              { internalType: "bytes", name: "composeMsg", type: "bytes" },
              { internalType: "bytes", name: "oftCmd", type: "bytes" },
            ],
            internalType: "struct SendParam",
            name: "_sendParam",
            type: "tuple",
          },
          {
            components: [
              { internalType: "uint256", name: "nativeFee", type: "uint256" },
              { internalType: "uint256", name: "lzTokenFee", type: "uint256" },
            ],
            internalType: "struct MessagingFee",
            name: "_fee",
            type: "tuple",
          },
          { internalType: "address", name: "_refundAddress", type: "address" },
        ],
        name: "send",
        outputs: [
          {
            components: [
              { internalType: "bytes32", name: "guid", type: "bytes32" },
              { internalType: "uint64", name: "nonce", type: "uint64" },
              {
                components: [
                  {
                    internalType: "uint256",
                    name: "nativeFee",
                    type: "uint256",
                  },
                  {
                    internalType: "uint256",
                    name: "lzTokenFee",
                    type: "uint256",
                  },
                ],
                internalType: "struct MessagingFee",
                name: "fee",
                type: "tuple",
              },
            ],
            internalType: "struct MessagingReceipt",
            name: "msgReceipt",
            type: "tuple",
          },
          {
            components: [
              {
                internalType: "uint256",
                name: "amountSentLD",
                type: "uint256",
              },
              {
                internalType: "uint256",
                name: "amountReceivedLD",
                type: "uint256",
              },
            ],
            internalType: "struct OFTReceipt",
            name: "oftReceipt",
            type: "tuple",
          },
        ],
        stateMutability: "payable",
        type: "function",
      },
    ] as const,
  },
} as const;

// Helper function to get contract config by chain
export function getContractByChain(chainId: number) {
  switch (chainId) {
    case 484: // Camp Network
      return CONTRACTS.CAMP_TIMELOCK_ESCROW;
    case 1: // Ethereum Mainnet
      return CONTRACTS.CAMP_OFT;
    default:
      return null;
  }
}

// Staking vault configuration - CAMP and wCAMP
export const STAKING_VAULTS = {
  CAMP: {
    id: "camp",
    name: "CAMP",
    symbol: "CAMP",
    decimals: 18,
    isNative: true,
    staker: CONTRACTS.CAMP_STAKER, // Special wrapper for native token staking
    vault: CONTRACTS.CAMP_STAKING_VAULT,
    tokenContract: null, // Native token, no ERC20 contract
  },
  WCAMP: {
    id: "wcamp",
    name: "wCAMP",
    symbol: "wCAMP",
    decimals: 18,
    isNative: false,
    staker: null, // No wrapper needed for ERC20 tokens
    vault: CONTRACTS.CAMP_STAKING_VAULT, // Same vault as CAMP (since CampStaker wraps CAMP to wCAMP)
    tokenContract: {
      address: "0x3bd5C81a8Adf3355078Dc5F73c41d3194B316690" as const,
      abi: [
        // Standard ERC20 functions needed for staking
        {
          inputs: [
            { internalType: "address", name: "owner", type: "address" },
            { internalType: "address", name: "spender", type: "address" },
          ],
          name: "allowance",
          outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
          stateMutability: "view",
          type: "function",
        },
        {
          inputs: [
            { internalType: "address", name: "spender", type: "address" },
            { internalType: "uint256", name: "amount", type: "uint256" },
          ],
          name: "approve",
          outputs: [{ internalType: "bool", name: "", type: "bool" }],
          stateMutability: "nonpayable",
          type: "function",
        },
        {
          inputs: [{ internalType: "address", name: "account", type: "address" }],
          name: "balanceOf",
          outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
          stateMutability: "view",
          type: "function",
        },
        {
          inputs: [],
          name: "decimals",
          outputs: [{ internalType: "uint8", name: "", type: "uint8" }],
          stateMutability: "view",
          type: "function",
        },
        {
          inputs: [],
          name: "name",
          outputs: [{ internalType: "string", name: "", type: "string" }],
          stateMutability: "view",
          type: "function",
        },
        {
          inputs: [],
          name: "symbol",
          outputs: [{ internalType: "string", name: "", type: "string" }],
          stateMutability: "view",
          type: "function",
        },
        {
          inputs: [],
          name: "totalSupply",
          outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
          stateMutability: "view",
          type: "function",
        },
        {
          inputs: [
            { internalType: "address", name: "to", type: "address" },
            { internalType: "uint256", name: "amount", type: "uint256" },
          ],
          name: "transfer",
          outputs: [{ internalType: "bool", name: "", type: "bool" }],
          stateMutability: "nonpayable",
          type: "function",
        },
        {
          inputs: [
            { internalType: "address", name: "from", type: "address" },
            { internalType: "address", name: "to", type: "address" },
            { internalType: "uint256", name: "amount", type: "uint256" },
          ],
          name: "transferFrom",
          outputs: [{ internalType: "bool", name: "", type: "bool" }],
          stateMutability: "nonpayable",
          type: "function",
        },
      ] as const,
    },
  },
} as const;

// Chain configuration
export const SUPPORTED_CHAINS = {
  CAMP_NETWORK: {
    id: 484,
    name: "Camp Network",
    symbol: "CAMP",
    contract: CONTRACTS.CAMP_TIMELOCK_ESCROW,
    stakingContracts: {
      staker: CONTRACTS.CAMP_STAKER,
      vault: CONTRACTS.CAMP_STAKING_VAULT,
    },
  },
  ETHEREUM_MAINNET: {
    id: 1,
    name: "Ethereum Mainnet",
    symbol: "ETH",
    contract: CONTRACTS.CAMP_OFT,
  },
} as const;

// Bridge configuration
export const BRIDGE_CONFIG = {
  DEFAULT_GAS_LIMIT: 3000000n, // Updated to match successful transaction (3M gas)
  DEFAULT_SLIPPAGE: 50n, // 0.5% in basis points (50/10000) - matches successful transactions
  MAX_SLIPPAGE: 10000n, // 100% in basis points
  HOLD_PERIOD_DAYS: 7,
} as const;

// Staking configuration
export const STAKING_CONFIG = {
  DEFAULT_GAS_LIMIT: 200000n, // Gas limit for staking operations
  REWARDS_DURATION_DAYS: 7, // 7 days reward period
  MIN_STAKE_AMOUNT: "0.001", // Minimum stake amount in CAMP
} as const;
